import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { Form } from 'src/app/shared/models/application/form';
import { FormType } from 'src/app/shared/models/application/formType';
import { FormService } from 'src/app/shared/services/form.service';
import { WidgetsService } from 'src/app/shared/services/widgets.service';
import { ChartData, Color } from 'src/app/shared/types/ng-charts.type';
import { WidgetInstanceModel } from '../../shared/models/widget.model';
import { RecentFormResponsesService } from './recent-form-responses.service';

@Component({
  selector: 'app-recent-form-responses',
  templateUrl: './recent-form-responses.component.html',
  styleUrls: ['./recent-form-responses.component.scss'],
  standalone: false,
  // Scoped per instance so two Recent Form Responses widgets don't share chart state.
  providers: [RecentFormResponsesService]
})
export class RecentFormResponsesComponent implements OnInit, OnDestroy {
  @Input() widgetInfo: WidgetInstanceModel;

  subscriptions: Subscription[] = [];
  chartData: ChartData;
  loaded = false;
  private _selectedFormId: string;
  private _forms: Form[] = [];
  itemPickerValues: ItemPickerModel[] = [];

  //By this color configuration only last bar of 4 bars gets a different color
  color: Color = { backgroundColor: ['#6c99ff', '#6c99ff', '#6c99ff', '#7a57cd'] };
  constructor(
    private recentFormResponsesService: RecentFormResponsesService,
    private formService: FormService,
    private widgetsService: WidgetsService
  ) {}
  ngOnInit(): void {
    this.formService.getAll();
    this._selectedFormId = this.widgetInfo?.settings?.selectedViewId;
    this.recentFormResponsesService.getRecentFormResponses(this._selectedFormId);
    this.subscriptions.push(
      this.formService.forms
        .pipe(
          map((forms) => forms.filter((f) => f.formType == FormType.Application && !f.hasExpired))
        )
        .subscribe((forms) => {
          if (!forms) return;
          this._forms = forms;
          this.itemPickerValues = [new ItemPickerModel(null, null, 'All Forms')].concat(
            forms.map((x) => new ItemPickerModel(x.id, null, x.title))
          );
        }),

      this.recentFormResponsesService.chartData.subscribe((result) => {
        this.loaded = true;
        this.chartData = result;
      })
    );
  }
  get selectedItemPickerValue(): ItemPickerModel {
    return (
      this.itemPickerValues.find((x) => x.id == this._selectedFormId) ?? this.itemPickerValues[0]
    );
  }
  itemPickerSelect(model: ItemPickerModel) {
    this._selectedFormId = this._forms.find((x) => x.id == model.id)?.id;
    this.loaded = false;
    this.recentFormResponsesService.getRecentFormResponses(this._selectedFormId);
    this.widgetInfo.settings = {
      ...this.widgetInfo.settings,
      selectedViewId: this._selectedFormId
    };
    this.widgetsService.updateInstanceSettings(this.widgetInfo);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
